<script setup lang="ts">
import _service from "@/service";
import { useAccountStore } from "@/stores/account";
import { Loading, showToast } from "vant";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import mallPng from "@/assets/integral/mall.png";
import couponPng from "@/assets/integral/coupon.png";
import starcenterPng from "@/assets/integral/starcenter.png";
import rechargePng from "@/assets/integral/recharge.png";
import signPng from "@/assets/integral/sign.png";
import WaterFallList from "./components/WaterFallList.vue";
import { getArmadillo } from "@/utils/armadillo";
import { iframePost } from "@/utils";
const router = useRouter();
const balance = ref("0");
const loading = ref(false);
const productList = ref<any>([]);
const accountStore = useAccountStore();
const tabList = [
  {
    url: "/integral/list",
    icon: mallPng,
    text: "积分商城",
  },
  {
    url: "*",
    icon: couponPng,
    text: "消费券",
  },
  {
    url: "",
    icon: starcenterPng,
    text: "StarCenter",
  },
  {
    url: "*",
    icon: rechargePng,
    text: "积分充值",
  },
  {
    url: "*",
    icon: signPng,
    text: "每日签到",
  },
];
const getUserBalance = async () => {
  const [_balance]: any = await _service.getBalanceByUser({
    code: "star.token",
    account: accountStore.getUserInfo.name,
    symbol: "STAR",
  });
  balance.value = _balance?.split(' ')[0];
};
const signFn = () => {
  console.log("sign");
  // setIsShow(true)
};
const getList = async () => {
  try {
    loading.value = true;
    const {
      data: { list },
    }: any = await _service.getIntegralProductList({
      pageNo: 1,
      pageSize: 20,
      saleLocation: 1,
    });
    console.log(list, "list");
    productList.value = list;
    loading.value = false;
  } catch (error) {}
};

watch(()=>accountStore.getUserInfo.name,(val)=>{
  console.log(`登录账号:${accountStore.getUserInfo.name}`);
  getUserBalance();
})

onMounted(() => {
  if (!(window as any).armadillo) {
    console.log('no armadillo');
  }
  if (accountStore.getUserInfo.name) {
    getUserBalance();
  }else{
    setTimeout(() => {
      accountStore.connectWallet;
    }, 1500);
  }
  getList();
});
</script>

<template>
  <div class="layout">
    <div class="integralbanner">
      <div class="flex-row-between-center">
        <span class="left">我的积分</span>
        <span
          class="right flex-row-start-center"
          @click="
            () => {
              router.push('/integral/records');
            }
          "
        >
          积分记录 <i class="icon rightarrow" />
        </span>
      </div>
      <div class="balance">
        <span class="number">{{ balance || 0 }}</span>
        STAR
      </div>
    </div>
    <div class="integraltabs flex-row-between-center">
      <div
        class="tab flex-col-center-center"
        v-for="item in tabList"
        :key="item.text"
        @click="
          () => {
            if (item.url.includes('*')) {
              // signFn()
              showToast('coming soon');
            } else {
              router.push(item.url);
            }
          }
        "
      >
        <img class="icon" :src="item.icon" alt="" />
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
    <div class="productlist">
      <div class="header flex-row-between-center">
        <span>好物甄选</span>
        <span
          class="more flex-row-start-center"
          @click="
            () => {
              router.push('/integral/list');
            }
          "
          >more<i class="icon rightarrow"
        /></span>
      </div>
      <div class="list">
        <div class="flex-row-center-center">
            <Loading v-if="loading"></Loading>
        </div>
        <WaterFallList :data="productList"></WaterFallList>
      </div>
    </div>
    <!-- <SignModal visible={isShow} onCancel={()=>{setIsShow(false)}} onOk={()=>{setIsShow(true)}}></SignModal> -->
  </div>
</template>

<style lang="scss" scoped>
.icon.rightarrow {
  width: 24px;
  height: 24px;
  background: url(../../assets/integral/right-arrow.svg);
  background-size: contain;
  background-repeat: no-repeat;
}
.layout {
  padding: 12px;
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  .integralbanner {
    width: 100%;
    background: #1f212d;
    border-radius: 16px;
    display: flex;
    padding: 18px 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      color: $text1;
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 12px; /* 100% */
    }
    .right {
      color: $text2;
    }
    .balance {
      width: 100%;
      color: $themColor2;
      font-size: 16px;
      font-weight: 700;
      gap: 8px;
      font-family: D-DINExp;
      .number {
        font-family: "D-DINExp";
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 0.90667rem;
        text-transform: capitalize;
        margin-right: 0.21333rem;
        background: linear-gradient(
          111deg,
          #fff853 4.98%,
          #6eef94 56.05%,
          #2ad8cd 95.37%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .integraltabs {
    margin-top: 22px;
    margin-bottom: 22px;
    .tab {
      gap: 8px;
      .icon {
        width: 40px;
        height: 40px;
      }
      .text {
        color: $text2;
        text-align: center;
        font-family: "Poppins";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px; /* 100% */
      }
    }
  }
  .productlist {
    .header {
      color: $text1;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      .more {
        color: $text2;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
    .list {
      margin-top: 10px;
    }
  }
}
</style>
